import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

import { environment } from '../../../environments/environment'
import { ApiResponse } from '../../shared/types/response.type'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class MaintenanceService {
	constructor(
		private readonly httpClient: HttpClient,
		private readonly router: Router,
	) {}

	fetchMaintenanceStatus() {
		return this.httpClient.get<ApiResponse<{ ON_MAINTENANCE: string }[]>>(`${API_URL}/api/service_config/maintenance`)
	}

	redirectToMaintenance() {
		this.router.navigate(['/maintenance'])
	}
}
